
import { defineComponent } from "vue";
import ColorPopover from "./ColorPopover.vue";
import { HEX2HSL } from "../../utils/color";

export default defineComponent({
  components: {
    ColorPopover,
  },
  props: {
    modelValue: { type: String, required: true },
    block: { type: Boolean, default: false },
    style: { type: Object, default: () => ({}) },
    name: { type: String, default: "" },
  },
  emits: [
    "update:modelValue",
  ],
  data: () => ({
    showPopover: false,
  }),
  computed: {
    dark(): boolean {
      return HEX2HSL(this.modelValue).l < 50;
    },
  },
  methods: {
    hidePopover(): void {
      this.showPopover = false;
    },
  },
});
